'use client';

import type { ContentCarouselProps } from './content-carousel.types';
import { ContentCarousel } from './ContentCarousel';

export function ContentCarouselBlock({ block }: ContentCarouselProps) {
  return <ContentCarousel block={block} />;
}
